module.exports = __webpack_public_path__ + "static/media/karimus.f2b337ba.svg";